export default {
  namespaced: true,
  state: {
    isEmbedMode: false,
    embedToken: null
  },
  mutations: {
    setEmbedMode(state, value) {
      state.isEmbedMode = value;
    },
    setEmbedToken(state, token) {
      state.embedToken = token;
    }
  },
  getters: {
    isEmbedMode: state => state.isEmbedMode,
    embedToken: state => state.embedToken
  },
  actions: {
    initializeEmbedMode({ commit }, { token }) {
      commit('setEmbedMode', true);
      commit('setEmbedToken', token);
    }
  }
}